import { apiPathFunc } from "@api/util/apiPathFunc";

import { setPassword } from "./setPassword/path";

import type { IExtractParams } from "@routes";

const pathBase = `/users/me/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const me = {
  get: apiPathFunc(pathBase),
  setPassword,
};
